export default {
    general: {
        add:            'Add',
        edit:           'Edit',
        delete:         'Delete',
        cancel:         'Cancel',
        close:          'Close',
        confirm:        'Confirm',
        save:           'Save',
        sign_out:       'Sign out',
        loading:        'Loading …',
        refresh:        'Refresh',
        search:         'Search',
        from:           'From',
        to:             'To',
        today:          'Today',
        previous_day:   'Previous day',
        previous:       'Previous',
        next:           'Next',
        next_day:       'Next day',
        all:            'All',
        all_facilities: 'All areas',
        name:           'Name',
        description:    'Description',
        email:          'Email',
        status:         'Status',
        active:         'Active',
        inactive:       'Inactive',
        copy:           'Copy',
        copied:         'Copied',
    },
    brand: {
        product_name: 'Rezervacije',
        tagline:      'Slots and resources',
    },
    nav: {
        customers:   'Customers',
        board:       'Board',
        bookings:    'Bookings',
        closures:    'Closures',
        settings:    'Settings',
        tenants:     'Customers',
        pms_installations: 'PMS installations',
        group_admin: 'Administration',
        reports:     'Reports',
        schedule:    'Schedule',
        my_schedule: 'My schedule',
    },
    layout: {
        open_menu:  'Open menu',
        close_menu: 'Close menu',
    },
    color_mode: {
        switch_to_light: 'Switch to light mode',
        switch_to_dark:  'Switch to dark mode',
    },
    errors: {
        generic_error:      'An error occurred',
        invalid_data:       'Invalid data',
        not_found:          'Not found',
        unauthorized:       'You are not signed in',
        forbidden:          'You are not allowed to do this',
        slot_unavailable:   'That time is no longer available',
        incorrect_status:   'The booking is in a state that does not allow this',
        already_exists:     'Already exists',
        cancel_not_allowed: 'It is too late to cancel',
        resource_in_use:    'The resource has upcoming bookings — its grid cannot change',
        pos_not_configured: 'Imprion POS is not set up',
        pos_failed:         'Imprion POS refused the request: {message}',
        pms_not_configured: 'Posting to the folio is not switched on for this hotel, or it has no key. An administrator sets it in Settings → Hotels and PMS.',
        pms_failed:         'The PMS refused the request: {message}',
        bill_not_possible:  'No bill can be issued for this booking (the service has no POS article or the amount is 0)',
        billing_in_progress: 'A bill for this booking is already being issued — wait a moment and refresh.',
        too_many_images:    'At most 8 images.',
        image_too_large:    'The image is larger than 5 MB.',
        on_add:             'Error while adding',
        on_edit:            'Error while saving',
    },
    success: {
        add:  'Successfully added',
        edit: 'Successfully saved',
    },
    validation: {
        required:  'This field is required',
        email:     'Invalid email address',
        min_chars: 'At least {n} characters',
    },
    login: {
        subtitle: 'Sign in to the back office',
        username: 'Username',
        password: 'Password',
        submit:   'Sign in',
        failed:   'Wrong username or password',
    },
    board: {
        pick_facility: 'Choose an area',
        no_facilities: 'There are no areas yet. Add one in Settings.',
        no_resources:  'This area has no resources. Add them in Settings.',
        closed_day:    'No resource is open on this day.',
        closed_week:   'No resource is open this week.',
        bookings_count: '{n} bookings',
        more:          '+{n} more',
        view: {
            day:   'Day',
            week:  'Week',
            month: 'Month',
        },
        capacity:      'up to {n} at once',
        legend: {
            free:    'Free',
            full:    'Full',
            blocked: 'Closed',
            closed:  'Outside hours',
            booking: 'Booking',
        },
    },
    availability: {
        pick_service_first: 'Choose a service first.',
        none:               'No free times on this day.',
    },
    booking: {
        booking:            'Booking',
        new:                'New booking',
        create:             'Book',
        none:               'No bookings.',
        code:               'Code',
        time:               'Time',
        facility:           'Area',
        service:            'Service',
        resource:           'Resource',
        customer:           'Customer',
        customer_name:      'Full name',
        customer_email:     'Email',
        customer_phone:     'Phone',
        amount:             'Amount',
        notes:              'Notes',
        created:            'Created',
        status_label:       'Status',
        source_label:       'Source',
        search_placeholder: 'Name, email, phone, code',
        pick_time:          'Choose a time',
        pick_other_time:    'Other time',
        move_title:         'Move to another time',
        move_same_resource: 'Same resource',
        confirm_cancel:     'Cancel this booking? The time will be freed.',
        status: {
            booked:    'Booked',
            completed: 'Completed',
            cancelled: 'Cancelled',
            no_show:   'No-show',
        },
        source: {
            staff:  'Staff',
            online: 'Online',
        },
        action: {
            complete:     'Completed',
            no_show:      'No-show',
            cancel:       'Cancel booking',
            reopen:       'Reopen',
            move:         'Move',
            move_confirm: 'Move here',
        },
    },
    closure: {
        subtitle:           'Holidays, time off, breakdowns — no new bookings while closed.',
        add:                'Add closure',
        none:               'No closures in this period.',
        facility:           'Area',
        resource:           'Resource',
        all_resources:      'All resources of the area',
        reason:             'Reason',
        reason_placeholder: 'e.g. Holiday',
        hint:               'Existing bookings stay; check them on the board.',
        to_after_from:      'The end must be after the start',
        confirm_delete:     'Remove this closure? The times open again.',
        deleted:            'Closure removed',
    },
    settings: {
        tab: {
            facilities: 'Areas',
            resources:  'Resources',
            services:   'Services',
            users:      'Users',
            general:    'General',
            pos:        'Imprion POS',
            pms:        'Hotels and PMS',
            gates:      'Gates',
            employees:  'Employees',
        },
        general_subtitle:   'Company details and the public booking page.',
        description_help:   'Shown on the public page.',
        contact_email:      'Contact email',
        contact_phone:      'Contact phone',
        address:            'Address',
        notify_email:       'Notification email',
        notify_email_help:  'Every online booking is announced here.',
        public_page:        'Public page',
        public_enabled:     'The public page is on',
        public_url:         'Address:',
        min_notice_minutes: 'Minimum minutes ahead',
        min_notice_help:    'How early a guest must book before the start.',
        max_days_ahead:     'Maximum days ahead',
        max_days_help:      'How far ahead a guest sees times (1–180).',
        access_heading:     'Access (QR code)',
        access_before:      'Minutes before start',
        access_before_help: 'How early the access code already opens the gate (0–240).',
        access_after:       'Minutes after end',
        access_after_help:  'How long after the end the code still opens the gate (0–240).',
    },
    facility: {
        subtitle:         'An area groups services and resources, e.g. Wellness or Sports centre.',
        add:              'Add area',
        edit:             'Edit area',
        none:             'There are no areas yet.',
        sort:             'Order',
        name_placeholder: 'e.g. Wellness',
        description_help: 'Shown on the public page above its services.',
        counts:           '{resources} resources · {services} services',
    },
    resource: {
        subtitle:         'A resource is what a service occupies: a person, equipment or a space. Its hours decide the free times.',
        add:              'Add resource',
        edit:             'Edit resource',
        none:             'There are no resources yet.',
        need_facility:    'Add an area first.',
        facility:         'Area',
        name_placeholder: 'e.g. Therapist Ana, Court 1',
        kind_label:       'Kind',
        grid:             'Grid',
        grid_help:        'Length of one cell; bookings start on this grid.',
        capacity:         'Capacity',
        capacity_help:    'How many bookings the resource takes at once.',
        hours:            'Hours',
        hours_help:       'Weekly opening hours; up to two windows a day.',
        kind: {
            person:    'Person',
            equipment: 'Equipment',
            space:     'Space',
        },
        follows_employee: 'The schedule of {name} decides — the resource’s weekly hours are not used.',
    },
    service: {
        pos_product:        'POS article',
        pos_product_help:   'The bill is issued on this article; the article also decides the VAT.',
        pos_product_none:   'No article — no bill can be issued',
        pos_product_clear:  'Remove article',
        tax_rate:           'VAT (for the folio line)',
        tax_rate_help:      'The rate the service is charged to a hotel folio at.',
        pos_vat:            'VAT {rate} %',
        pos_badge:          'POS',
        pos_linked:         'Linked to an Imprion POS article',
        subtitle:           'A service is what a guest books. It lasts a number of the resource\'s cells.',
        add:                'Add service',
        edit:               'Edit service',
        none:               'There are no services yet.',
        facility:           'Area',
        name_placeholder:   'e.g. Massage 60 min',
        duration:           'Duration',
        price:              'Price',
        pool:               'Resources',
        pool_all:           'All resources of the area',
        pool_help:          'Which resources can perform the service. Empty means every resource of the area.',
        cells:              'Number of cells',
        cells_help:         'Duration: {minutes}',
        cells_help_empty:   'The area has no resources yet.',
        extra:              'Additional resources',
        extra_add:          'Add',
        extra_help:         'Resources the service occupies alongside the main one, e.g. a second therapist for a couples massage.',
        extra_pick:         'Choose resources for this role',
        extra_empty:        'Choose at least one resource',
        extra_count:        '{n} additional',
        guest_cancel_hours: 'Guest may cancel (hours before start)',
        guest_cancel_help:  '0 = until the start, -1 = the guest cannot cancel.',
        fees:               'Late cancellation and no-show',
        fees_help:          'What a late cancellation or a no-show costs, as a share of the price. Each booking keeps the rules in force when it was made. The amount is recorded on the booking and charged with the monthly settlement with the hotel.',
        late_cancel_hours:  'Late cancellation (hours before start)',
        late_cancel_fee:    'Late cancellation (%)',
        no_show_fee:        'No-show (%)',
        public:             'On the public page',
        public_short:       'Public',
    },
    pos: {
        title:                'Imprion POS',
        subtitle:             'When a booking is completed, the till issues a fiscal bill.',
        not_configured_title: 'Imprion POS is not available',
        not_configured:       'The platform has no Imprion POS address set up. Please contact your provider.',
        enabled:              'Issue bills through Imprion POS',
        enabled_help:         'On completion, staff pick the payment type and the till issues the bill.',
        token:                'API key',
        token_help:           'The key of your Imprion POS (External API).',
        token_saved:          'The key is saved — leave empty to keep it',
        save_token_first:     'Save the key first, then pick the business unit and the cash register.',
        business_unit:        'Business unit',
        cash_register:        'Cash register',
        pick:                 'Pick one',
        test:                 'Test connection',
        test_ok:              'The Imprion POS connection works',
    },
    bill: {
        title:              'Bill',
        number:             'Number',
        amount:             'Amount',
        issued_at:          'Issued',
        eor_pending:        'EOR not received yet',
        issue:              'Issue bill',
        issue_title:        'Issuing the bill',
        complete_title:     'Complete and bill',
        payment_type:       'Payment type',
        pick_payment_type:  'Pick a payment type',
        complete_with:      'Complete and issue bill',
        complete_without:   'Complete without a bill',
    },
    hours: {
        open:          'Open',
        closed:        'Closed',
        from:          'From',
        to:            'To',
        add_window:    'Second window',
        remove_window: 'Remove window',
        copy_monday:   'Copy Monday to every day',
        invalid:       'Invalid hours: the end must be after the start and the two windows must not overlap.',
        works:         'Works',
        day_off:       'Day off',
        split_shift:   'Split shift',
        add_break:     'Meal break',
        break:         'Meal break',
        break_short:   'break',
        remove_break:  'Remove the meal break',
        break_invalid: 'The meal break must lie within the working time and end after it starts.',
        day: {
            mon: 'Monday',
            tue: 'Tuesday',
            wed: 'Wednesday',
            thu: 'Thursday',
            fri: 'Friday',
            sat: 'Saturday',
            sun: 'Sunday',
        },
        short: {
            mon: 'Mon',
            tue: 'Tue',
            wed: 'Wed',
            thu: 'Thu',
            fri: 'Fri',
            sat: 'Sat',
            sun: 'Sun',
        },
    },
    user: {
        subtitle:      'Who can sign in to the back office.',
        add:           'Add user',
        edit:          'Edit user',
        none:          'No users.',
        role_label:    'Role',
        password_help: 'At least 8 characters.',
        password_keep: 'Leave empty to keep the current password.',
        self_locked:   'You cannot change your own role or switch yourself off.',
        role: {
            platform_admin: 'Platform admin',
            admin:          'Administrator',
            staff:          'Staff',
        },
    },
    tenant: {
        subtitle:    'Companies using Rezervacije. Each has its own database.',
        add:         'Add customer',
        edit:        'Edit customer',
        none:        'There are no customers yet.',
        name:        'Company name',
        slug:        'Handle',
        slug_help:   'Part of the public page address; lowercase letters, digits and hyphens. Cannot be changed later.',
        slug_locked: 'The handle cannot be changed.',
        slug_invalid: '3–40 characters: lowercase letters, digits, hyphens',
        timezone:    'Timezone',
        public:      'Public page',
        first_admin: 'First administrator',
    },
    image: {
        preview:        'Enlarge picture',
        previous:       'Previous picture',
        next:           'Next picture',
        position:       'Picture {n} of {total}',
        cover:          'Cover',
        add:            'Add',
        replace:        'Replace',
        delete:         'Delete image',
        confirm_delete: 'The image will be deleted.',
        move_left:      'Move left',
        move_right:     'Move right',
        help:           'JPG, PNG or WebP, up to 5 MB, at most {n}. The first is the cover.',
        help_single:    'JPG, PNG or WebP, up to 5 MB.',
        wrong_type:     'only JPG, PNG and WebP images are allowed',
        uploaded:       'Images uploaded: {n}',
        photos:         'Images',
        after_save:     'Images can be added once the area or resource is saved.',
        logo:           'Logo',
        logo_help:      'Shown in the menu and on the public booking page.',
    },
    series: {
        repeat:            'Repeat',
        frequency:         'Frequency',
        daily:             'Daily',
        weekly:            'Weekly',
        every:             'Every',
        unit_days:         'days',
        unit_weeks:        'weeks',
        end:               'Ends',
        end_count:         'After a number of times',
        end_until:         'On a date',
        count:             'Number of times',
        until:             'Last day',
        summary:           '{count}× {pattern} at {time}, last on {last}',
        summary_none:      'No occurrence falls in the chosen span.',
        every_day:         'every day',
        every_n_days:      'every {n} days',
        weekday_every: {
            1: 'every Monday',
            2: 'every Tuesday',
            3: 'every Wednesday',
            4: 'every Thursday',
            5: 'every Friday',
            6: 'every Saturday',
            0: 'every Sunday',
        },
        every_n_weeks:     'every {n} weeks ({weekday})',
        max_hint:          'At most 52 occurrences.',
        create:            'Create series',
        created:           '{n} bookings created',
        result_title:      'Series created',
        result_booked:     'Booked: {n}',
        result_skipped:    'These could not be booked (taken or closed):',
        title:             'Recurring series',
        loading:           'Loading series …',
        cancel_following:  'Cancel this and all following',
        cancel_all:        'Cancel the whole series',
        confirm_following: 'Cancel this and every following booked occurrence of the series?',
        confirm_all:       'Cancel every booked occurrence of the series? Completed ones stay.',
        cancelled:         '{n} cancelled',
        current:           'this',
    },
    access: {
        title:       'Access',
        valid:       'Valid from {from} to {until}',
        valid_same_day: 'Valid on {day} from {from} to {until}',
        download:    'Download QR code',
        code:        'Code',
    },
    gate: {
        subtitle:        'Code readers at doors, turnstiles and barriers.',
        add:             'Add gate',
        edit:            'Edit gate',
        none:            'No gates yet.',
        facility:        'Area',
        resources:       'Resources',
        resources_help:  'Which resources the gate opens for. Empty = every resource of the area.',
        all_resources:   'All resources',
        last_seen:       'Last seen',
        never_seen:      'Never',
        new_key:         'New key',
        new_key_confirm: 'The old key stops working at once. The reader must be set up with the new key.',
        key_title:       'Reader key',
        key_once:        'The key is shown only once. Store it in the reader settings.',
        reader_title:    'For the reader',
        reader_get:      'The reader sends the scanned code to this address:',
        reader_post:     'Or POST to the same address with the header Authorization: Bearer <key> and the body:',
        reader_answer:   'HTTP 200 means open, 403 means do not open.',
        key_placeholder: 'key',
        code_placeholder: 'scanned code',
    },
    report: {
        title:          'Reports',
        tab: {
            bills:         'Bills',
            bookings:      'Bookings',
            cancellations: 'Cancellations',
            access:        'Entries',
        },
        total:          'Total',
        issued_at:      'Issued',
        number:         'Number',
        booking:        'Booking',
        customer:       'Customer',
        service:        'Service',
        payment_type:   'Payment type',
        amount:         'Amount',
        eor:            'EOR',
        eor_pending:    'pending',
        no_bills:       'No bills issued in this period.',
        bookings_total: 'Bookings',
        completed:      'Completed',
        cancelled:      'Cancelled',
        no_show:        'No-show',
        online_share:   'Online',
        amount_booked:  'Booked value',
        amount_billed:  'Billed',
        count:          'Count',
        by_service:     'By service',
        no_services:    'No bookings in this period.',
        start_at:       'Slot',
        cancelled_at:   'Cancelled',
        cancelled_by:   'Cancelled by',
        via:            'Who',
        via_staff:      'Staff',
        via_guest:      'Guest',
        hours_before:   'Before',
        no_cancellations: 'No cancellations in this period.',
        at:             'Time',
        gate:           'Gate',
        result:         'Result',
        allowed:        'Opened',
        denied:         'Denied',
        reason:         'Reason',
        no_access:      'No entries in this period.',
        range_too_long: 'The period can be at most 400 days.',
        reasons: {
            unknown_code: 'Unknown code',
            wrong_gate:   'Wrong gate',
            too_early:    'Too early',
            expired:      'Expired',
            cancelled:    'Cancelled',
        },
    },
    customer: {
        subtitle:             'Everybody who has booked — for analysis and marketing.',
        search_placeholder:   'Name, e-mail or phone',
        none:                 'No customers.',
        name:                 'Customer',
        card:                 'Customer card',
        back:                 'Back to customers',
        bookings:             'Bookings',
        bookings_n:           '{n} bookings',
        bookings_title:       'Customer bookings',
        completed:            'Completed',
        cancelled:            'Cancelled',
        no_show:              'No-show',
        upcoming:             'Upcoming',
        spent:                'Spent',
        first_at:             'First visit',
        last_at:              'Last visit',
        next_at:              'Next booking',
        favourite:            'Favourite service',
        online_share:         'Online',
        bill:                 'Bill',
        notes:                'Notes about the customer',
        count:                'Customers',
        with_consent:         'With marketing consent',
        total_spent:          'Total spent',
        consent:              'Consent',
        consent_any:          'All',
        consent_yes:          'Consents',
        consent_no:           'No consent',
        consent_label:        'Agrees to receive news and offers',
        consent_staff_label:  'Agrees to receive news',
        consent_none:         'No marketing consent.',
        consent_given:        'Consent given {at} {source}',
        consent_source: {
            online: '(online booking)',
            staff:  '(staff)',
        },
        any_service:          'All services',
        inactive_days:        'Inactive for more than (days)',
        min_bookings:         'At least bookings',
        sort:                 'Sort',
        sort_last_at:         'Last visit',
        sort_spent:           'Spent',
        sort_bookings:        'Number of bookings',
        sort_name:            'Name',
        export:               'Export CSV (with consent)',
        merge:                'Merge',
        merge_with:           'Merge with …',
        merge_title:          'Merge customer',
        merge_help:           "Find the other card of the same person. Its bookings move to {name} and the card is deleted.",
        merge_confirm:        "{other}'s bookings will move to {target} and the card {other} will be deleted.",
        merged:               'Customers merged',
        erase:                'Erase customer (GDPR)',
        erase_do:             'Erase permanently',
        erase_confirm:        "{name}'s card will be erased permanently, and in their bookings the name, e-mail and phone will be replaced with “Erased”. Times, services and amounts stay for the reports. This cannot be undone.",
        erased:               'Customer erased',
    },
    employee: {
        subtitle:              'Employees, their shifts and links to resources and user accounts.',
        none:                  'No employees yet.',
        add:                   'Add employee',
        edit:                  'Edit employee',
        position:              'Position',
        position_placeholder:  'e.g. therapist, instructor',
        phone:                 'Phone',
        resource:              'Booked as resource',
        resource_help:         'Only when guests book this employee (e.g. a massage with a therapist): the resource’s free slots will follow their schedule. Leave it “not linked” for reception and the like.',
        resource_help_empty:   'No free resource of kind “person”. Needed only when guests book this employee — add one under Settings → Resources.',
        user:                  'User account',
        user_help:             'Signed in, they see their schedule under "My schedule".',
        none_linked:           '— not linked —',
        color:                 'Colour in the schedule',
        no_color:              'No colour',
        notes:                 'Notes',
        default_hours:         'Weekly template',
        default_hours_help:    'Working time per day; the meal break cannot be booked but counts as working time. "Fill from template" fills a week from it.',
    },
    schedule: {
        employee:              'Employee',
        total:                 'Total',
        off:                   'Off',
        outside_count:         '{n} outside shift',
        fill:                  'Fill from template',
        fill_text:             'Shifts for the week {week} are filled from each employee’s weekly template.',
        fill_keep:             'Keep existing',
        fill_overwrite:        'Overwrite all',
        filled:                'Shifts created: {n}',
        copy_previous:         'Copy previous week',
        copy_confirm:          'Last week’s shifts are copied into the week {week}. This week’s shifts are replaced.',
        copied:                'Shifts copied: {n}',
        add_absence:           'Add absence',
        absence_kind:          'Type',
        absence_help:          'During an absence the linked resource’s slots are closed.',
        from_date:             'From',
        to_date:               'To',
        range_invalid:         '"To" must not be before "from".',
        span:                  'Period',
        note:                  'Note',
        note_placeholder:      'e.g. afternoon at reception',
        day_off:               'Day off',
        save_failed:           'The shift could not be saved',
        shift_during_absence:  'The employee is absent this day ({kind}).',
        absences_week:         'Absences this week',
        delete_absence_confirm: 'Delete the absence of {name}?',
        outside_title:         'Bookings outside the shift',
        outside_subtitle:      'Bookings that are no longer within the employee’s shift after a schedule change.',
        no_employees:          'No active employees. Add them in Settings → Employees.',
        week_total:            'This week: {hours}',
        not_linked:            'Your account is not linked to an employee.',
        absence: {
            vacation:          'Vacation',
            sick:              'Sick leave',
            other:             'Absence',
        },
    },
    demo: {
        signing_in:        'Signing in for the demo …',
        unavailable_title: 'No demo here',
        unavailable:       'One-click sign-in works only on a presentation server and only for known roles.',
        to_login:          'To sign-in',
    },
    about: {
        title:            'About',
        version:          'Version',
        build:            'Build',
        changelog:        'Changes',
        update_available: 'New version — reload',
        update_toast:     'A new version of Rezervacije is available. Reload the page.',
    },
    partner: {
        title:                 'Partner hotels',
        subtitle:              'The hotels you work with. Each has its own PMS installation, folio key, integration keys and contract. A hotel sees only its own prices and bookings.',
        none:                  'No hotels yet.',
        add:                   'Add hotel',
        edit:                  'Edit hotel',
        name:                  'Hotel',
        name_help:             'E.g. "Hotel Bled".',
        hotel:                 'Hotel',
        installation:          'PMS installation',
        installation_help:     'The Imprion PMS installation the hotel runs on. The platform provider keeps the list.',
        installation_pick:     'Pick an installation',
        installation_required: 'Pick a PMS installation to post to the folio.',
        no_installation:       'No PMS installation',
        active_help:           'An inactive hotel cannot book and cannot be picked; its keys stop working.',
        folio:                 'Folio',
        folio_on:              'To folio',
        folio_off:             'No',
        contract_now:          'Contract today',
        contract_none:         'No contract (price list)',
        contracts:             'Contracts',
        contracts_title:       'Contracts — {name}',
        contracts_subtitle:    'A discount for the hotel\'s guests, a commission to the hotel, or a net price. A change applies to new bookings only; bookings made keep their price.',
        contracts_none:        'No contract yet — the hotel\'s guests pay the price list.',
        keys:                  'Keys',
        keys_title:            'Integration keys — {name}',
        keys_subtitle:         'With a key this hotel\'s PMS reads free times and its own prices, and books. A key sees only this hotel\'s bookings. It is entered in the PMS, on the property.',
        amount_by_contract:    'By the hotel\'s contract.',
        pricing_title:         'Price by contract (version {version})',
        pricing_no_contract:   'Hotel guest price (no contract)',
        price_list:            'Price list',
        price_discount:        'Discount ({pct} %)',
        price_guest:           'Guest pays',
        price_hotel:           'To the hotel',
        price_facility:        'To us',
        fee_late_cancel:       'Late cancellation',
        fee_no_show:           'No-show',
    },
    contract: {
        add:                   'New contract',
        edit:                  'Edit contract',
        version:               'Version',
        version_help:          'Saving makes version {next}. Bookings made under version {version} keep their price.',
        span:                  'In force',
        valid_from:            'From',
        valid_to:              'Until',
        valid_to_help:         'Empty = until further notice.',
        valid_to_before:       'The end is before the start.',
        open_ended:            'until further notice',
        payment_terms:         'Payment terms (days)',
        payment_terms_help:    'For the monthly settlement.',
        settlement:            'Settlement',
        settlement_room:       'To the room (hotel resells)',
        settlement_room_help:  'The service goes on the guest\'s folio and the hotel bills it. You invoice the hotel monthly for your share.',
        settlement_self:       'We bill the guest',
        settlement_self_help:  'The guest pays you; the hotel gets a commission.',
        lines:                 'Terms',
        lines_help:            'Per facility and, optionally, per service — a service\'s terms win. A facility without terms goes by the price list.',
        lines_none:            'No terms — all by the price list.',
        line_add:              'Add terms',
        facility:              'Facility',
        service:               'Service',
        all_services:          'All services of the facility',
        discount:              'Discount (%)',
        commission:            'Commission (%)',
        net_price:             'Net price',
        net_price_none:        'none',
        notes:                 'Notes',
        state_now:             'In force',
        state_future:          'Upcoming',
        state_past:            'Past',
        example_room:          'E.g. {service}: list {list}, guest pays {guest}, hotel keeps {commission}, you {net}.',
        example_net:           'E.g. {service}: list {list}, guest pays {guest}, you {net}, hotel keeps {hotel}.',
        example_self:          'E.g. {service}: list {list}, guest pays you {guest}, commission to the hotel {commission}.',
        history:               'History',
        history_title:         'Contract history',
        history_subtitle:      'Every save is a new version. Bookings keep the price of the version they were made under.',
        history_first:         'First version.',
        history_same:          'Saved without changing the terms.',
        version_n:             'Version {n}',
        version_current:       'in force',
        payment_terms_n:       'payment in {n} days',
        term_discount:         'discount {pct}',
        term_commission:       'commission {pct}',
        term_net:              'net price {amount}',
        changed_span:          'In force: {from} → {to}',
        changed_settlement:    'Settlement: {from} → {to}',
        changed_terms:         'Payment terms: {from} → {to} days',
        changed_notes:         'Notes changed',
        changed_line:          '{subject}: {from} → {to}',
        changed_line_added:    'Terms added — {line}',
        changed_line_removed:  'Terms removed — {line}',
    },
    installation: {
        subtitle:              'The Imprion PMS installations partner hotels can run on. Customers pick from this list and never type an address.',
        none:                  'No installations yet.',
        add:                   'Add installation',
        edit:                  'Edit installation',
        name_help:             'How customers see it, e.g. "Imprion PMS".',
        base_url:              'API address',
        base_url_help:         'Up to /api/pms/v1, e.g. https://recepcija.pms.imprion.dev/api/pms/v1.',
        base_url_invalid:      'The address must start with https://.',
        active_help:           'Customers do not see an inactive installation and links to it stop working.',
    },
    pms: {
        link_title:            "To the guest's folio",
        link_subtitle:         "A hotel guest's completed service goes as a line onto their folio in Imprion PMS. The hotel bills the guest at check-out; Rezervacije issue no bill for that booking.",
        not_configured_title:  'PMS is not set up',
        not_configured:        'The platform has no Imprion PMS installation yet. Contact your provider.',
        enabled:               "Post to the guest's folio in Imprion PMS",
        enabled_help:          "Staff pick the hotel guest on a booking; on completion the service goes onto their folio.",
        key:                   'Folio key (issued by the hotel)',
        key_help:              'The hotel issues the key in the PMS (property → Fiscalisation → "Tills and connections" → Issue key); the PMS needs the "Dining (POS)" module. It is only the way to the folio — no till issues a bill.',
        key_saved:             'A key is saved — leave empty to keep it',
        cash_register_name:    'Label on the folio',
        cash_register_help:    "Shown beside every line on the guest's folio, e.g. \"Rezervacije\" or \"Wellness\".",
        test:                  'Test connection',
        test_ok:               'Connection works — {n} occupied rooms',

        keys_title:            'Integration keys',
        keys_subtitle:         'They let the PMS or another system read free times and make and cancel bookings.',
        keys_none:             'No keys yet.',
        key_create:            'New key',
        key_name_help:         'E.g. "Imprion PMS — Hotel Bled".',
        key_created_title:     'New integration key',
        key_prefix:            'Key',
        key_last_used:         'Last used',
        key_never_used:        'Never used',
        key_revoke:            'Revoke',
        key_revoke_confirm:    'Revoke the key "{name}"? The system using it loses access.',
        key_placeholder:       'key',
        developers:            'For developers',
        developers_help:       'Base address and header for every call:',

        hotel_guest:           'Hotel guest',
        hotel_guest_help:      'On completion the service goes onto their folio in the PMS.',
        hotel_guest_none:      'Not a hotel guest',
        hotel_guest_search:    'Room or surname …',
        hotel_guest_clear:     'Remove the hotel guest',
        until:                 'until {date}',
        room_guest:            'Room {room} · {guest}',
        room:                  'Room',
        pick_room:             'Pick a room',
        settle_hint:           'Hotel guest: room {room} · {guest}.',
        folio_off:             'Folio posting is switched off for the hotel "{hotel}", so the service cannot go on the guest\'s folio. An administrator switches it on in Settings → Hotels and PMS → hotel.',
        complete_to_room:      'Complete and post to folio',
        charge_room:           'Post to folio',
        charge_confirm:        'Post',
        charge_title:          "On the guest's folio",
        charge_bill:           'Number',
        charge_posted:         'Posted',
        charge_voided:         'reversed',
    },
}
